import { notification } from 'antd';
import { saveAs } from 'file-saver';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../App.context';
import { ApiContext } from '../networking/Api.context';

export default function useCheckInStatsExportHook() {
  const { appActions } = useContext(AppContext);
  const { API } = useContext(ApiContext);

  const [state, setState] = useState({
    loading: false,
  });

  useEffect(() => {
    appActions.setExportingInProgress(state.loading);
  }, [, state.loading]);

  const checkinStatsExportActions = {
    export: (hotel, dateFrom, dateTo) => {
      updateState({ loading: true });
      API.checkinsStatsExportRequest(hotel, dateFrom, dateTo)
        .then(data => {
          notification.success({
            message: 'Exportación del resumen de checkins completada!',
          });
          saveAs(
            new Blob([data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            }),
            'checkins_stats_export.xlsx'
          );
        })
        .catch(error => {
          console.warn(error);
        })
        .finally(() => {
          updateState({ loading: false });
        });
    },
  };

  function updateState(object) {
    setState(previousState => ({ ...previousState, ...object }));
  }

  return { checkinStatsExportActions };
}
